global.SENTRY_RELEASE={};
global.SENTRY_RELEASE.id="3.5.0";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@sentry/webpack-plugin/src/sentry-webpack.module.js
// module id = ./node_modules/@sentry/webpack-plugin/src/sentry-webpack.module.js
// module chunks = 7